import React from "react";

interface IPaginationContext {
  maxPreloadedPage: number;
  pageIndex: number;
  perPage: number;
  setMaxPreloadedPage: (pageIndex: number) => void;
  setPageIndex: (pageIndex: number) => void;
  setPerPage: (pageIndex: number) => void;
}

export const PageContext = React.createContext<IPaginationContext>({
  maxPreloadedPage: 0,
  pageIndex: 0,
  perPage: 0,
  setMaxPreloadedPage: (_: number) => {
    return;
  },
  setPageIndex: (_: number) => {
    return;
  },
  setPerPage: (_: number) => {
    return;
  },
});
export const PageContextProvider = PageContext.Provider;
